import styled from 'styled-components';

const DelaySettingStyle = styled.div`
  .card {
    height: 13vh;
    .card-header {
      h5 {
        font-size: 1rem;
      }
    }
    .card-body {
      padding: 0.25em;
      p {
        margin: 0 auto;
        width: 95%;
        font-size: 0.9rem;
      }
      .form-control {
        border-radius: 15px;
        width: 95%;
        margin: 0 auto;
        height: 3vh;
      }
    }
  }

  @media (max-width: 1280px) {
    .card {
      .card-body {
        .form-control {
          padding: 0.25em 0.75em;
        }
      }
    }
  }
`;

export default DelaySettingStyle;
